<style lang="less" scoped="">
  #box{
     width: 100%;
    height: 30px;
    overflow: hidden;
    // margin-top: -10px;
    margin-left: -9px;
    z-index: 200;
    padding-left: 30px;
    //background-color: #f0f0f0;
  }
  .anim{
    transition: all 0.5s;
    margin-top: -30px;
  }
  #con1 li{
    list-style: none;
    line-height: 30px;
    height: 30px;
    font-size: 12px;
    color: red;
  }
  #con1 li img{
    vertical-align: middle;
    margin-bottom: 4px;
  }
</style>
<template>
<div id="box" v-model="show">
  <ul id="con1" ref="con1" :class="{anim:animate==true}">
    <li v-for="item in items">
    <img src="../../../static/laba.gif" height="25" width="25"/>
      <span>{{item}}</span>
    </li>
  </ul>
</div>
</template>
<script>
  export default {
    name: 'Announcement',
    components: {
    },
    data () {
      return {
        show: false,
        animate: false,
        items: [],
      }
    },
    created () {
      // this.init()
    },
    methods: {
      scroll () {
        this.animate = true
        let self = this
        setTimeout(() => {
          if (self.items) {
            self.items.push(self.items[0])
          }
          self.items.shift()
          self.animate = false
        }, 500)
      },
      getNewOrders () {
        let self = this
        let items = []
        self.$http.get('/fundPackage/getNewOrders').then(function (res) {
          if (res.data) {
            self.show = true
            for (let i = 0; i < res.data.length; i++) {
              items[i] = res.data[i] + ''
            }
            self.items = items
          } else {
            self.show = false
          }
        })
      },
      init () {
        // this.getNewOrders()
        // setInterval(this.getNewOrders, (60 * 60 * 1000))
        // setInterval(this.scroll, 6000)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Announcement.vue?50d0face